/**
 * @generated SignedSource<<49aaa66b70967d204b42df69f6426080>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowIncludedLabelsInline_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useItemPriceData_item">;
  readonly " $fragmentType": "useShowIncludedLabelsInline_item";
};
export type useShowIncludedLabelsInline_item$key = {
  readonly " $data"?: useShowIncludedLabelsInline_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowIncludedLabelsInline_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowIncludedLabelsInline_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "24661fe7e557fafdfc0fd5c0ce0e354b";

export default node;
